// extracted by mini-css-extract-plugin
export default {"modal":"CandidateManagementModal-module__modal__e3-1j","content":"CandidateManagementModal-module__content__WZZqG"};